import {getVisited} from '@/store/setters'
export default {
    install(Vue) {
        Vue.prototype.$getVisited = getVisited
    },
  }